import React from 'react'
import { IconProps } from '../../../common/types'

const PaymentSettingsIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M2 10.688h20m-10.452 10.5h-5.11c-3.55 0-4.45-.88-4.45-4.39v-8.22c0-3.18.74-4.2 3.53-4.36.28-.01.59-.02.92-.02h11.11c3.55 0 4.45.88 4.45 4.39v4.41M6 16.687h4m6.441 1.999.99.99 2.13-1.97m1.859 3.04a3.97 3.97 0 0 1-3.42 1.94 3.97 3.97 0 0 1-3.42-1.94 3.9 3.9 0 0 1-.58-2.06c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .75-.21 1.46-.58 2.06"
      ></path>
    </svg>
  )
}

export default PaymentSettingsIcon
